import { Divider } from "@msuite/ui/divider";
import { ColorPicker, Select, Textarea, TextInput } from "@msuite/ui/form";
import { VisibilityIcon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { WikiSpaceSchema } from "@msuite/utils/schemas";
import type { Enums } from "@msuite/utils/types";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useMentionOptions } from "@/hooks/use-mention-options";

export function WikiSpaceForm() {
	/** Hooks */
	const methods = useFormContext<WikiSpaceSchema>();
	const { t } = useTranslation();
	const mentionsOptions = useMentionOptions();

	/** Render */
	return (
		<React.Fragment>
			<Select
				control={methods.control}
				name="visibility"
				label={t("visiblity.visiblity")}
				isRequired
				isNullable={false}
				itemNotFoundLabel={t("general.not_found")}
				options={[
					{ label: t("visiblity.restricted"), value: "restricted", item: null },
					{ label: t("visiblity.public"), value: "public", item: null },
					{ label: t("visiblity.private"), value: "private", item: null },
				]}
				renderOption={(_, label, value) => (
					<div className="h-stack">
						<VisibilityIcon visibility={value as Enums<"visibility">} />
						<p>{label}</p>
					</div>
				)}
			/>
			<Divider variant="modal" />
			<TextInput
				label={t("wiki.space_name")}
				control={methods.control}
				name="name"
				isRequired
				placeholder="Enter space name..."
			/>
			<Textarea
				isRequired={false}
				label={t("wiki.space_description")}
				control={methods.control}
				name="description"
				disableFormatting
				{...mentionsOptions}
			/>
			<ColorPicker
				isRequired
				control={methods.control}
				name="color"
				label={t("theme.color")}
			/>
		</React.Fragment>
	);
}
